import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeAsnDocumentActionAsync } from '../redux/actions/typeAsnDocumentActions'

export const useTypeAsnDocument = () => {
  const { typeAsnDocumentState } = useSelector(
    (state: RootState) => state.typeAsnDocument
  )
  const dispatch = useDispatch()

  const getTypeAsnDocument = () => {
    dispatch(getTypeAsnDocumentActionAsync())
  }

  return { typeAsnDocumentState, getTypeAsnDocument }
}
